module.exports = __webpack_public_path__ + "static/media/logo-terra-brasil.527234c4.png";